<ion-header>
  <ion-toolbar class="blues-nav">
    <ion-row>
      <ion-col size="2" class="nav-back">
        <span class="custom-icon-back-arrow-icon" (click)="back()">
          <span class="path1"></span> <span class="path2"></span> </span>
      </ion-col>
      <ion-col size="10" class="nav-content">
        <ion-title>
          <span>Bonus</span>
        </ion-title>
      </ion-col>
    </ion-row>
  </ion-toolbar>
</ion-header>

<ion-content>
  <div class="estimates-empty-div">
    <ion-item lines="none" class="estimates">
      <span slot="start" class="head-title">Bonus</span>
      <!-- <span slot="end" class="custom-icon-dashboard-invoice-icons"></span> -->

      <div slot="end" class="edit-icon">
        <span class="custom-icon-edit-icon" (click)="editBonus()"></span>
        <span class="custom-icon-delete-icon" (click)="deleteBonus(null)"></span>
      </div>

    </ion-item>
  </div>
  <div class="estimates-content-div">
    <div class="profile-list payslip">
      <img src="./assets/imgs/Logo-new.png" class="paySlipLogo">

      <ion-row>
        <ion-col>
          <div class="invoice-details1">
            <h5 class="inv-company head-name">Pay Date
              <span>{{ currentBonus?.payDate | date : 'd MMM y'}}</span>
            </h5>
          </div>
        </ion-col>
        <ion-col>
          <div class="invoice-details">
            <h5 class="inv-company head-name">Status
              <!-- <span>{{ currentBonus?.durationInDays | dateAddDays: currentBonus?.startDate | date : 'd MMM y' }}</span> -->
              <span>{{ currentBonus?.status}}</span>
            </h5>
          </div>
        </ion-col>
      </ion-row>
      
      <ion-row>
        <ion-col>          
          <h5 class="inv-company head-name">% Base</h5>
          <div class="inv-receiver">            
            <h3 class="inv-receiver-address">{{ currentBonus?.basePerc }}%</h3>
          </div>
        </ion-col>
        <ion-col class="text-center">          
          <h5 class="inv-company head-name">% Capital</h5>
          <div class="inv-receiver">
            <h3 class="inv-receiver-address">{{ currentBonus?.capitalPerc }}%</h3>
          </div>
        </ion-col>
        <ion-col class="text-center">          
          <h5 class="inv-company head-name">% Annual</h5>
          <div class="inv-receiver">
            <h3 class="inv-receiver-address">{{ currentBonus?.annualPerc }}%</h3>
          </div>
        </ion-col>
        <ion-col class="inv-recieve">          
          <h5 class="inv-company head-name">% Level</h5>
          <div class="inv-receiver">
            <h3 class="inv-receiver-address">{{ currentBonus?.levelPerc }}</h3>
          </div>
        </ion-col>
      </ion-row>
      
      <ion-row>
        <ion-col>          
          <h5 class="inv-company head-name">Type</h5>
          <h3 class="inv-receiver-address">{{ currentBonus?.type }}</h3>          
        </ion-col>
      </ion-row>

      <ion-row>
        <ion-col>          
          <h5 class="inv-company head-name">Total</h5>
          <h3 class="inv-receiver-address">{{ currentBonus?.total | currency:'EUR' }}</h3>
        </ion-col>
      </ion-row>

      <!-- <br>
      <ion-row>
        <ion-button class="centered" color="primary" (click)="open(currentBonus?.file)">
          View document
        </ion-button>
      </ion-row> -->

    </div>
  </div>
</ion-content>
